<template>
  <div v-if="true">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="
    this.getUser.pref.select.cdid !== null &&
    this.getUser.pref.select.cdid !== ''
    "
    :disabled="!(this.getActionRegister.length < 26) || !this.enableDocumentItemAdd()">
      <v-icon left>
        add
      </v-icon>
      New
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Action
              </div>
            </span>
            <v-spacer/>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                {{localForm.tag}}
              </div>
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
            {{actionTitlePrefix}}  {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="task"
                  hint="action name or title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="generated id"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-4">
                <div :class="ui.textSubheading">
                  Action Scope and Description
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                   v-model="localForm.itemScope"
                   :disabled="false"
                   :outline="true"
                   required
                   :rules="ruleMustBeFilledANDLessThan1000"
                   hint="action description, scope and summary"
                   auto-grow
                   persistent-hint
                   ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.type"
                    :items="actionType"
                    label="action type"
                    prepend-icon="grid_view"
                    hint="action type"
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.theme"
                    :items="actionTheme"
                    label="action theme"
                    prepend-icon="emoji_symbols"
                    hint="theme"
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.dis"
                    :items="engineeringDiscipline"
                    label="discipline"
                    prepend-icon="engineering"
                    hint="discipline"
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.resrc"
                    :items="actionResourceTypeOptions"
                    label="resources"
                    prepend-icon="widgets"
                    hint="resource"
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout class="text-xs-left ml-3 mr-2 mt-2 hidden-sm-and-up">
                <div :class="ui.textSubheadingBold">
                  {{localForm.name}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  Company
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.cname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only"
              v-if="
              this.getDetailLink !== null &&
              this.getDetailLink !== undefined &&
              this.getDetailLink.fdid !== ''
              ">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.getUser.pref.select.fdid !== ''">
                  {{this.getDetailLink.ft}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-else>
                  Not Selected
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Source
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <div v-if="this.getDetail !==  null">
                    {{getDetail.basic.title}}
                  </div>
                  <div v-else>
                    Not Defined
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> pin </v-icon>
                  </v-avatar>
                  IDM
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{this.displayDocumentIDGTypeA(
                    this.getDetailBasic.tag,
                    this.getDetailBasic.idg
                  )}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> task </v-icon>
                  </v-avatar>
                  Incident
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_symbols </v-icon>
                  </v-avatar>
                  Theme
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Discipline
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> widgets </v-icon>
                  </v-avatar>
                  Resources
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.resrc}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.itemScope}}
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNewAction()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNewAction()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import linkFunctions from "@/data/functions/mixins/linkFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import actionOptions from "@/data/options/mixins/actionOptions.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import role from "@/data/forms/mixins/role.js";
import roleFunctions from "@/data/functions/mixins/roleFunctions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import generateRoles from "@/support/roles/mixins/generateRoles.js";
import generateAction from "@/business/actions/mixins/generateAction.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
  },
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    linkFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    describeDocument,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    transFunctions,
    actionOptions,
    roleFunctions,
    role,
    listFunctions,
    relps,
    generateRoles,
    generateAction,
    displayFunctions,
    techOptions,
    documentFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        tag: "",
        type: "",
        theme: "",
        itemScope: "",
        dis: "",
        resrc: ""
      },
      info: [
        {
          step: 0,
          title: "Action Request",
          // eslint-disable-next-line
          msg: "Action is required to clarify business / technical uncertainty or to resolve known risk.",
          icon: ""
        },
        {
          step: 1,
          title: "Action Classification",
          // eslint-disable-next-line
          msg: "Action type and theme specification is required to assign the right person or team to complete the action with appropriate budget and plan.",
          icon: ""
        },
        {
          step: 2,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. Please return to previous steps if required.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  beforeMount() {
    // GENERATE ID
    if (this.getDetailBasic !== null) {
      let id = this.generateIDfromMaster(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg,
        this.getActionRegisterCounter
      );
      this.localForm.tag = id;
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getDetail",
      "getDetailLink",
      "getActionList",
      "getActionListCounter",
      "getActionRegister",
      "getActionRegisterCounter",
      "getTransitions"
    ]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    actionTitlePrefix() {
      let prefix = null;
      if (
        this.getDetailLink !== null &&
        this.getDetailLink.fdid !== null &&
        this.getDetailLink.fdid !== ""
      ) {
        prefix = "Facility";
      } else {
        prefix = "Company";
      }
      return prefix;
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 2 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (
        this.step == 0 &&
        this.localForm.name !== "" &&
        this.localForm.itemScope !== ""
      ) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.dis !== "" &&
        this.localForm.resrc !== "" &&
        this.localForm.theme !== "" &&
        this.localForm.type !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      this.btnSpinChangeDetail = false;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewAction() {
      this.btnSpinChangeDetail = true;

      // SET data source
      const tag = "B3";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");
      const idm = this.displayDocumentIDGTypeA(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg
      );
      // GENERATE form
      let temp = this.generateActionForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.idm = idm;
      temp.basic.tag = tag;
      temp.basic.save = true; // save with enabled.
      temp.basic.id = this.localForm.tag;
      temp.basic.act = true; // set asset to true
      temp.basic.title = this.localForm.name;
      // CHAR
      temp.char.scope = this.localForm.itemScope;
      temp.char.type = this.localForm.type;
      temp.char.theme = this.localForm.theme;
      temp.char.dis = this.localForm.dis;
      temp.char.resrc = this.localForm.resrc;
      // CHAR - GENERATE JUST.
      let mtag = this.getDetailBasic.tag; // master tag
      let just = "Action was generated by ";
      just = just + this.defineDocumentFromTag(mtag).title + " ";
      just = just + this.getDetailBasic.title + " ";
      just = just + idm + ".";
      temp.char.just = just;

      // STATS
      temp.stats.dcrt = moment().format();
      // eslint-disable-next-line
      temp.stats.ddue = moment().add(1, 'months').format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag);
      temp.trans = trans;

      // LINK - COMPANY AND FACILIUTY DATA
      // COMPANY DATA is to IDENTIFY where the ACTION is STORED
      // WHICH MAY BE DIFFERENT TO COMPANY SIGN IN BY USER
      if (this.getDetail !== null) {
        temp.link.sdid = this.getDetailBasic.did;
        temp.link.st = this.getDetailBasic.title;
        temp.link.sid = this.getDetailBasic.id;
        temp.link.sidg = this.getDetailBasic.idg;
        temp.link.stag = this.getDetailBasic.tag;
      }
      if (this.getUser.pref.select.cdid !== "") {
        temp.link.cdid = this.getUser.pref.select.cdid;
        temp.link.ct = this.getUser.pref.select.cname;
        temp.link.cid = this.getUser.pref.select.cid;
        temp.link.cidg = this.getUser.pref.select.cidg;
      }
      // Only select Facility if Parent is alos Facility select
      if (
        this.getDetailLink !== null &&
        this.getDetailLink.fdid !== undefined &&
        this.getDetailLink.fdid !== ""
      ) {
        temp.link.fdid = this.getDetailLink.fdid;
        temp.link.ft = this.getDetailLink.ft;
        temp.link.fid = this.getDetailLink.fid;
        temp.link.fidg = this.getDetailLink.fidg;
      }
      // HELP
      console.log("NEW ACTION");
      console.log(temp);

      // UPDATE ACTION REGISTER / MASTER DOC
      this.addActionToActionRegister(temp);
      this.changeDetail();

      // CREATE ACTION
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
